import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { color } from 'styled-system';
import { Label as BaseLabel } from '../../shared/FormStyles';
import defaultAttrs from '../../lib/utils/defaultAttrs';

const Wrapper = styled.div`
  position: relative;
  font-family: 'Montserrat';
  width: 100%;
`;

const FileInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid;
  border-radius: 8px;
  border-color: ${({ error }) =>
    error ? themeGet('colors.error.default') : themeGet('colors.black.20')};
  position: relative;
  overflow: hidden;
  padding: 10px 16px;
  font-size: 12px;
  color: ${themeGet('colors.black.60')};
  margin-top: 8px;
  position: relative;
`;

const InputFile = styled.input`
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  opacity: 0;
  margin: 0 !important;
`;

const FileName = styled.span`
  color: ${({ isFileUploaded }) =>
    isFileUploaded
      ? themeGet('colors.black.100')
      : themeGet('colors.black.60')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.2px;
  width: 65%;
  text-align: end;
`;

const FileButton = styled.a`
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  ${color}
`;

const LogoErrorMessage = styled.span`
  ${color};
  position: absolute;
  font-weight: 400;
  right: 0;
  top: calc(100% + 6px);
  font-size: 12px;
`;

const InformationIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-circle-info fa-sm',
  }),
)`
  margin: 0 4px;
`;

const Label = styled(BaseLabel)`
  margin-bottom: 8px;
`;

export const FileInput = ({
  id,
  name,
  fileTypes,
  fileName,
  fileButtonColor = 'primary.100',
  onChange,
  errorMessage,
  onBlur,
  label,
  dataTip,
  dataOffset,
}) => {
  return (
    <Wrapper>
      {label && (
        <Label htmlFor={name}>
          {label}
          {dataTip && (
            <InformationIcon data-tip={dataTip} data-offset={dataOffset} />
          )}
        </Label>
      )}
      <FileInputWrapper error={!!errorMessage}>
        <FileButton color={fileButtonColor}>Browse File</FileButton>
        <FileName isFileUploaded={fileName}>
          {fileName || 'No file uploaded'}
        </FileName>
        <InputFile
          id={id}
          name={name}
          type="file"
          onChange={onChange}
          accept={fileTypes}
          onBlur={onBlur}
        />
      </FileInputWrapper>
      {errorMessage && (
        <LogoErrorMessage color="error.default">
          {errorMessage}
        </LogoErrorMessage>
      )}
    </Wrapper>
  );
};
